import React from 'react';

// Manual text uses **bold** and `Butang` (a control on screen); render both without injecting HTML.
export const ManualText = ({ text }) => {
    const parts = String(text || '').split(/(\*\*[^*]+\*\*|`[^`]+`)/g).filter(Boolean);
    return (
        <>
            {parts.map((part, index) => {
                if (part.startsWith('**') && part.endsWith('**')) {
                    return <strong key={index}>{part.slice(2, -2)}</strong>;
                }
                if (part.startsWith('`') && part.endsWith('`')) {
                    return <span key={index} className="app-manual-ui">{part.slice(1, -1)}</span>;
                }
                return <React.Fragment key={index}>{part}</React.Fragment>;
            })}
        </>
    );
};

export const plainText = (text) => String(text || '').replace(/\*\*|`/g, '');

// Media URLs from the API are relative signed paths (/api/manual/media/...); resolve them against the API host.
export const mediaUrl = (url) => {
    if (!url) return '';
    try {
        return new URL(url, process.env.REACT_APP_API_URL || window.location.origin).toString();
    } catch (e) {
        return url;
    }
};

// "/app/complaints/:id" style patterns from the manual content.
export const routeMatches = (pattern, pathname) => {
    const escaped = String(pattern)
        .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
        .replace(/\\\*/g, '.*')
        .replace(/:[A-Za-z]+/g, '[^/]+');
    return new RegExp(`^${escaped}/?$`).test(pathname);
};

export const ROLE_CLASS = {
    hq: 'is-hq',
    pi: 'is-pi',
    pengesah: 'is-pengesah',
    daerah: 'is-daerah',
    pengadu: 'is-pengadu',
    admin: 'is-admin',
};
